import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('dataTableDropdown');

    return {
        ALL_DATA: t('allData'),
        APPLICATIONS: t('applications'),
        ASSETS: t('assets'),
        BOUNDARIES: t('boundaries'),
        CLIENTS: t('clients'),
        FARMS: t('farms'),
        FIELDS: t('fields'),

        REPORTS: t('reports'),
        USERS: t('users')
    };
};

export default useTranslation;
